import React from 'react'
import { Card, Row } from 'antd'
import { EmptyHeaderHero, SEO } from './components'
import { getDomain } from '../utils'

import AccessStyle from '../../styles/GlobalAccessibility.module.css'

const GlobalAccessibility = () => {
  const redirectChat = () => {
    const chatDomain = getDomain('chat')
    window.location.href = `https://${chatDomain}`
  }
  
  return (
    <>
      <SEO
        title={"Website Accessibility | CURE Auto Insurance"} 
        description={"CURE auto insurance ensures website accessibility for all. Need help? Contact us at 800-535-CURE (2873) to connect with Customer Support."} 
        url={"/accessibility"}
      />
      <EmptyHeaderHero className={`${AccessStyle["mobile-header"]}`} leftAlign={true} minHeight={true} title="Website Accessibility" />
      <div className={`${AccessStyle["global-accessibility-screen"]}`}>
        <Row justify="center">
          <Card className={`${AccessStyle["global-accessibility-card"]}`}>
            <div className={`${AccessStyle["container"]}`}>
              CURE auto insurance believes in making our website accessible for all customers, including individuals
              with disabilities. If you have trouble reading or accessing material on our site, please{' '}
              <a className={`${AccessStyle["bold-text"]}`} href="/contact" rel="noopener noreferrer">
                contact us
              </a>
              . You may also choose to use our{' '}
              <div
                className={`${AccessStyle["bold-text"]}`}
                style={{ display: 'inline-block' }}
              >
                <a onClick={() => redirectChat()}>
                  Live Chat
                </a>
              </div>{' '}
              Customer Service at{' '}
              <a className={`${AccessStyle["mobile"]}`} href="tel:+18005352873">
                <span>800-535-CURE (2873)</span>
              </a>
              <span className={`${AccessStyle["desktop"]}`}>800-535-CURE (2873)</span> to connect with a representative.
            </div>
          </Card>
        </Row>
      </div>
    </>
  )
}

GlobalAccessibility.propTypes = {}

export default GlobalAccessibility
